import Loader from "@common/Loader";

import DefaultLayout from "./layout/DefaultLayout";

import { ToastContainer } from "react-toastify";
import { useAuthAppInitializer } from "./hooks/useAuthAppInitializer";
import { AppRoutes } from "./routes/Routes";

function App() {
  const form: {
    loading: boolean;
    error: string;
    isAdminLoggedIn: any;
    sessionExpired: boolean;
    connectionChecked: boolean;
    isConnected: boolean | undefined;
    noUserFound: boolean;
    userData: any;
  } = useAuthAppInitializer();

  return form.loading ? (
    <Loader />
  ) : (
    <DefaultLayout>
      <ToastContainer></ToastContainer>
      <AppRoutes></AppRoutes>
    </DefaultLayout>
  );
}

export default App;
